import React, { useState } from "react";

type AuthModalProps = {
  setAuthModalIsOpen: (value: boolean) => void;
};

const pageStyle: React.CSSProperties = {
  minHeight: "100vh",
  background: "transparent",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "24px",
};

const cardStyle: React.CSSProperties = {
  width: "100%",
  maxWidth: "460px",
  background: "var(--surface)",
  borderRadius: "32px",
  padding: "36px",
  boxShadow: "0 18px 50px rgba(20, 20, 20, 0.06)",
  border: "1px solid var(--line)",
};

const badgeStyle: React.CSSProperties = {
  display: "inline-block",
  padding: "8px 14px",
  borderRadius: "999px",
  background: "var(--surface-2)",
  border: "1px solid var(--line-2)",
  color: "var(--accent)",
  fontSize: "12px",
  fontWeight: 800,
  letterSpacing: "0.05em",
  textTransform: "uppercase",
  marginBottom: "18px",
};

const titleStyle: React.CSSProperties = {
  fontSize: "34px",
  lineHeight: 1.1,
  fontWeight: 800,
  color: "var(--text)",
  margin: "0 0 10px 0",
  letterSpacing: "-0.03em",
  fontFamily: "Montserrat",
  textTransform: "uppercase",
};

const subtitleStyle: React.CSSProperties = {
  fontSize: "15px",
  color: "var(--text-muted)",
  margin: "0 0 28px 0",
  lineHeight: 1.6,
};

const formStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "16px",
};

const fieldWrapStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
};

const labelStyle: React.CSSProperties = {
  fontSize: "13px",
  color: "var(--text-dim)",
  marginBottom: "8px",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
};

const inputStyle: React.CSSProperties = {
  height: "54px",
  borderRadius: "16px",
  border: "1px solid var(--line)",
  padding: "0 16px",
  fontSize: "15px",
  color: "var(--text)",
  outline: "none",
  background: "var(--bg-soft)",
};

const buttonStyle: React.CSSProperties = {
  height: "54px",
  border: "none",
  borderRadius: "16px",
  background: "var(--accent)",
  color: "var(--on-accent)",
  fontSize: "16px",
  fontWeight: 700,
  cursor: "pointer",
  marginTop: "6px",
  boxShadow: "var(--glow)",
};

const hintStyle: React.CSSProperties = {
  marginTop: "18px",
  fontSize: "13px",
  color: "var(--text-dim)",
  lineHeight: 1.6,
  textAlign: "center",
};

const errorStyle: React.CSSProperties = {
  marginTop: "8px",
  fontSize: "14px",
  color: "var(--danger)",
  fontWeight: 700,
};

function AuthModal({ setAuthModalIsOpen }: AuthModalProps) {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [errorText, setErrorText] = useState("");

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (login === "admin" && password === "Ybrjveytgjrfpsdfqnt") {
      setErrorText("");
      localStorage.setItem("auth", "true");
      setAuthModalIsOpen(true);
    } else {
      setErrorText("Неверный логин или пароль");
    }
  };

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <div style={badgeStyle}>БАТЯ ЗНАЕТ • Admin</div>

        <h1 style={titleStyle}>Вход в админ-панель</h1>

        <p style={subtitleStyle}>
          Введите логин и пароль, чтобы открыть панель управления вендинговыми
          автоматами и партнёрами.
        </p>

        <form onSubmit={handleSubmit} style={formStyle}>
          <div style={fieldWrapStyle}>
            <label style={labelStyle}>Логин</label>
            <input
              type="text"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              style={inputStyle}
              placeholder="Введите логин"
            />
          </div>

          <div style={fieldWrapStyle}>
            <label style={labelStyle}>Пароль</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={inputStyle}
              placeholder="Введите пароль"
            />
          </div>

          <button type="submit" style={buttonStyle}>
            Войти
          </button>
        </form>

        {errorText && <div style={errorStyle}>{errorText}</div>}

      </div>
    </div>
  );
}

export default AuthModal;